import ClickToSeeButton from './ClickToSeeButton';

export default ClickToSeeButton;
